import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import simpleParallax from 'simple-parallax-js';

var FloatingBg = /*#__PURE__*/function () {
  function FloatingBg(parent, items) {
    _classCallCheck(this, FloatingBg);

    this.parent = parent;
    this.items = items;
  }

  _createClass(FloatingBg, [{
    key: "init",
    value: function init() {
      this.parent.classList.add('loaded');
      this.items.forEach(function (item, index) {
        new simpleParallax(item, {
          overflow: true,
          scale: index % 2 === 0 ? 6 : 4
        });
      });
    }
  }]);

  return FloatingBg;
}();

export { FloatingBg as default };